// File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/VerifyEmailPage.js

import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import AuthService from '../../services/authService';
import './AuthPages.css';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const status = searchParams.get('status');

  const [pageStatus, setPageStatus] = useState('loading'); // loading | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    // Case 1: Backend already verified and redirected with ?status=success
    if (status === 'success') {
      setPageStatus('success');
      return;
    }

    // Case 2: Backend redirected with ?status=error or ?status=expired
    if (status === 'error' || status === 'expired') {
      setPageStatus('error');
      setError('Der Verifizierungslink ist ungültig oder abgelaufen.');
      return;
    }

    // Case 3: Frontend receives a token and needs to call the API
    if (token) {
      const verifyEmail = async () => {
        try {
          await AuthService.verifyEmail(token);
          setPageStatus('success');
        } catch (err) {
          setPageStatus('error');
          setError(err.message || 'Verifizierung fehlgeschlagen');
        }
      };

      verifyEmail();
      return;
    }

    // Case 4: No token and no status — invalid link
    setPageStatus('error');
    setError('Ungültiger Verifizierungslink');
  }, [token, status]);

  if (pageStatus === 'loading') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-loading-spinner" role="img" aria-hidden="true">⏳</span>
            <h2 className="auth-status-card__title">E-Mail wird verifiziert…</h2>
          </div>
        </div>
      </div>
    );
  }

  if (pageStatus === 'success') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-status-card__icon" role="img" aria-hidden="true">✅</span>
            <h2 className="auth-status-card__title">E-Mail bestätigt!</h2>
            <p className="auth-status-card__message">
              Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du kannst dich jetzt anmelden.
            </p>
            <Link to="/login" className="auth-action-btn">
              Zur Anmeldung
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-status-card">
          <span className="auth-status-card__icon" role="img" aria-hidden="true">❌</span>
          <h2 className="auth-status-card__title">Verifizierung fehlgeschlagen</h2>
          <p className="auth-status-card__message">{error}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)', width: '100%', maxWidth: '240px' }}>
            <Link to="/login" className="auth-action-btn">
              Zur Anmeldung
            </Link>
            <Link to="/login" className="auth-action-btn auth-action-btn--outline">
              Neuen Link anfordern
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}